import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearRoutePlanReportDetails,
  clearRoutePlanReportList,
  setRoutePlanReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Button } from "@progress/kendo-react-buttons";
import {
  // calculateTotalRow,
  checkAcessRights,
  // getUnitTypes,
} from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import { clearItemList } from "../../Item/itemSlice";
import { getAllRoutePlanReport } from "../services/reports.services";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FormMultiSelectionFiled from "../../../components/formFields/FormMultiSelectionFiled";
import {
  findAllAreaAssignDistributor,
  getAllAreaAssignToDistributor,
} from "../../areaAssignToDistributor/services/areaAssignToDistributor.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import moment from "moment";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const ChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  const distributor_id = formRenderProps.valueGetter("distributor_id");
  const dispatch = useAppDispatch();
  useEffect(() => {
    formRenderProps.onChange("monday", { value: "" });
    formRenderProps.onChange("tuesday", { value: "" });
    formRenderProps.onChange("wednesday", { value: "" });
    formRenderProps.onChange("thursday", { value: "" });
    formRenderProps.onChange("friday", { value: "" });
    formRenderProps.onChange("saturday", { value: "" });
    if (distributor_id) {
      dispatch(getAllAreaAssignToDistributor(distributor_id));
    }
  }, [distributor_id]);

  return null;
};

const RoutePlanReportForm: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);

  const RoutePlanReportDetails = useAppSelector(
    (state) => state.reports.RoutePlanReportDetails
  );
  const RoutePlanReportList = useAppSelector(
    (state) => state.reports.RoutePlanReportList
  );

  const DistributorList = useAppSelector(
    (state) => state.areaAssign.DistributorList
  );
  const AssignAreaList = useAppSelector(
    (state) => state.areaAssign.AssignAreaList
  );

  //   const currentPage = useAppSelector((state) => state.pagination.currentPage);
  //   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(findAllAreaAssignDistributor());
    return () => {
      dispatch(clearRoutePlanReportDetails());
      dispatch(clearRoutePlanReportList());
      //   dispatch(setCurrentPage(0));
      dispatch(clearItemList());
    };
  }, []);

  const handleSubmit = (values: any) => {
    const payload = {
      distributor_id: values?.distributor_id,
      monday: values?.monday ? values?.monday.join(",") : "",
      tuesday: values?.tuesday ? values?.tuesday.join(",") : "",
      wednesday: values?.wednesday ? values?.wednesday.join(",") : "",
      thursday: values?.thursday ? values?.thursday.join(",") : "",
      friday: values?.friday ? values?.friday.join(",") : "",
      saturday: values?.saturday ? values?.saturday.join(",") : "",
    };
    dispatch(getAllRoutePlanReport(payload));
    dispatch(setRoutePlanReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={RoutePlanReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <ChangeWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Walking Order Report
                    </Typography.h4>
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="distributor_id"
                      label="Distributor"
                      wrapperStyle={{ margin: "10px 0" }}
                      placeholder="Select Distributor"
                      component={FormSelectionField}
                      options={DistributorList.map((distributor: any) => ({
                        value: distributor.id,
                        label: distributor.account_name,
                      }))}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  {formRenderProps.valueGetter("distributor_id") && (
                    <>
                      <GridLayoutItem colSpan={3}></GridLayoutItem>
                      <GridLayoutItem>
                        <Typography.h6 style={{ margin: "0" }}>
                          Monday
                        </Typography.h6>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="monday"
                          wrapperStyle={{ margin: "0" }}
                          placeholder="Select Area"
                          component={FormMultiSelectionFiled}
                          options={AssignAreaList.map((distributor: any) => ({
                            value: distributor.area_id,
                            label: distributor.area_name,
                          }))}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                      <GridLayoutItem>
                        <Typography.h6 style={{ margin: "0" }}>
                          Tuesday
                        </Typography.h6>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="tuesday"
                          wrapperStyle={{ margin: "0" }}
                          placeholder="Select Area"
                          component={FormMultiSelectionFiled}
                          options={AssignAreaList.map((distributor: any) => ({
                            value: distributor.area_id,
                            label: distributor.area_name,
                          }))}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                      <GridLayoutItem>
                        <Typography.h6 style={{ margin: "0" }}>
                          Wednesday
                        </Typography.h6>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="wednesday"
                          wrapperStyle={{ margin: "0" }}
                          placeholder="Select Area"
                          component={FormMultiSelectionFiled}
                          options={AssignAreaList.map((distributor: any) => ({
                            value: distributor.area_id,
                            label: distributor.area_name,
                          }))}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                      <GridLayoutItem>
                        <Typography.h6 style={{ margin: "0" }}>
                          Thursday
                        </Typography.h6>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="thursday"
                          wrapperStyle={{ margin: "0" }}
                          placeholder="Select Area"
                          component={FormMultiSelectionFiled}
                          options={AssignAreaList.map((distributor: any) => ({
                            value: distributor.area_id,
                            label: distributor.area_name,
                          }))}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                      <GridLayoutItem>
                        <Typography.h6 style={{ margin: "0" }}>
                          Friday
                        </Typography.h6>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="friday"
                          wrapperStyle={{ margin: "0" }}
                          placeholder="Select Area"
                          component={FormMultiSelectionFiled}
                          options={AssignAreaList.map((distributor: any) => ({
                            value: distributor.area_id,
                            label: distributor.area_name,
                          }))}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                      <GridLayoutItem>
                        <Typography.h6 style={{ margin: "0" }}>
                          Saturday
                        </Typography.h6>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="saturday"
                          wrapperStyle={{ margin: "0" }}
                          placeholder="Select Area"
                          component={FormMultiSelectionFiled}
                          options={AssignAreaList.map((distributor: any) => ({
                            value: distributor.area_id,
                            label: distributor.area_name,
                          }))}
                        />
                      </GridLayoutItem>
                    </>
                  )}

                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <div style={{ marginTop: "35px", textAlign: "end" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
        {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : (
          RoutePlanReportList &&
          RoutePlanReportList.length > 0 && (
            <ShadowCard style={{ marginTop: 10, minHeight: "30vh" }}>
              <RoutePlanExportTable />
            </ShadowCard>
          )
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

const RoutePlanExportTable: React.FC = () => {
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );

  const RoutePlanReportList = useAppSelector(
    (state) => state.reports.RoutePlanReportList
  );
  const RoutePlanReportDetails = useAppSelector(
    (state) => state.reports.RoutePlanReportDetails
  );

  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const handlePrint = (props: any, type: string) => {
    const state = {
      distributor_id: props?.distributor_id,
      monday: props?.monday,
      tuesday: props?.tuesday,
      wednesday: props?.wednesday,
      thursday: props?.thursday,
      friday: props?.friday,
      saturday: props?.saturday,
      initialValues: props.initialValues,
    };

    if (type === "routeplanreport") {
      sessionStorage.setItem("routeplanreportState", JSON.stringify(state));
      const reportTab = window.open("/routeplanreportprint", "_blank");
      const interval = setInterval(() => {
        if (reportTab?.closed) {
          sessionStorage.removeItem("routeplanreportState");
          clearInterval(interval);
        }
      }, 1000);
    }
  };

  

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(
      ".employee-details-report-table"
    ) as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(
      `${RoutePlanReportList[0]?.distributor_name}`
    );
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "center", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0 || rowIndex === 1) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffabab" },
          };
        }
        /*===*===* LAST ROW STYLE *===*===*/
        // if (rowIndex === rows.length - 1) {
        //   excelCell.font = { bold: true };
        //   excelCell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "D9E1F2" },
        //   };
        // }
        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;

          if (colSpan > 3) {
            excelCell.font = { bold: true };
            excelCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "aff6af" },
            };
          }
          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `Walking Order Report - ${
          RoutePlanReportList[0]?.distributor_name
        } -${moment().format("DD-MM-YYYY_hh-mm-A")}.xlsx`
      );
    });
  };
  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const initialValues = {
    filter_columns: [
      "retailer_name",
      "area_name",
      "contact_person",
      "mobile_no",
      "rating",
    ],
  };
  const columns = [
    { label: "Retailer Name", value: "retailer_name" },
    { label: "Area Name", value: "area_name" },
    { label: "Contact Person", value: "contact_person" },
    { label: "Mobile No", value: "mobile_no" },
    { label: "Rating", value: "rating" },
  ];
  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };
  return (
    <>
      {RoutePlanReportList && RoutePlanReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Walking Order Report
                      <>
                        <p style={{ fontSize: 16 }}>
                          Distributor Name :-{" "}
                          {RoutePlanReportList[0]?.distributor_name}
                        </p>
                      </>
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {isPrintAccess && (
                        <Button
                          style={{ marginRight: 5 }}
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={() =>
                            handlePrint(
                              {
                                ...RoutePlanReportDetails,
                                initialValues: {
                                  filter_columns:
                                    formRenderProps.valueGetter(
                                      "filter_columns"
                                    ),
                                },
                              },
                              "routeplanreport"
                            )
                          }
                        >
                          Print
                        </Button>
                      )}
                      {isExcelAccess && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={handleExportExcel}
                          style={{ marginRight: 10 }}
                        >
                          Excel Export
                        </Button>
                      )}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 1,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 340px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  employee-details-report-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                            position: "sticky",
                            top: 0,
                          }}
                        >
                          <th style={{ minWidth: 50 }}>SR. No</th>

                          {checkInclude("retailer_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 100 }}>Retailer Name</th>
                            </>
                          )}
                          {checkInclude("area_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 180 }}>Area Name</th>
                            </>
                          )}
                          {checkInclude("contact_person", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 200 }}>Contact Person</th>
                            </>
                          )}
                          {checkInclude("mobile_no", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }}>Mobile No</th>
                            </>
                          )}
                          {checkInclude("rating", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 200 }}>Rating</th>
                            </>
                          )}
                        </tr>
                      </thead>
                      {/* Table Body */}
                      <tbody>
                        {RoutePlanReportList.map(
                          (item: any, rowIndex: number) => (
                            <>
                              <tr key={rowIndex}>
                                <td
                                  colSpan={
                                    formRenderProps.valueGetter(
                                      "filter_columns"
                                    ).length + 1
                                  }
                                  style={{
                                    backgroundColor: "#ffc8c8",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>
                                    <span>{item.day_of_week}</span> <br />
                                    <span>Area :- {item.area_name_list}</span>
                                  </strong>
                                  <br />
                                </td>
                              </tr>
                              {item.reatiler_list?.map(
                                (retailer: any, innerIndex: number) => (
                                  <tr>
                                    <td>{innerIndex + 1}</td>
                                    {checkInclude(
                                      "retailer_name",
                                      formRenderProps
                                    ) && <td>{retailer.retailer_name}</td>}
                                    {checkInclude(
                                      "area_name",
                                      formRenderProps
                                    ) && <td>{retailer.area_name}</td>}
                                    {checkInclude(
                                      "contact_person",
                                      formRenderProps
                                    ) && <td>{retailer.contact_person}</td>}
                                    {checkInclude(
                                      "mobile_no",
                                      formRenderProps
                                    ) && <td>{retailer.mobile_no}</td>}
                                    {checkInclude(
                                      "rating",
                                      formRenderProps
                                    ) && <td>{retailer.rating}</td>}
                                  </tr>
                                )
                              )}
                            </>
                          )
                        )}
                        {/* Total Row */}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default RoutePlanReportForm;
